import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { loadAuthSession } from '../helpers/authStorage.helper';

const PrivateRoute = ({ isAuthenticated }) => {
    const location = useLocation();
    const hasSession = Boolean(loadAuthSession()?.loggedIn);
    const canAccess = Boolean(isAuthenticated || hasSession);

    return canAccess ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRoute;
